// extracted by css-extract-rspack-plugin
export default {"language-selector-item":"UIZZQT","languageSelectorItem":"UIZZQT","language-selector":"w07_6n","languageSelector":"w07_6n"};